import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { BreakableEmail } from "../UI/Table/BreakableEmail.tsx";
import { BasicTable } from "../UI/Table/BasicTable.tsx";
import { EmptyTableMessage } from "../UI/Table/EmptyTableMessage.tsx";
import { formatDate, formatDateTime } from "../UI/Utils/formatDate.ts";
import { IssuedGiftCardRecordDTO } from "./types.ts";

const HIDDEN_ON_MOBILE = { className: "hidden md:table-cell" };

const columnHelper = createColumnHelper<IssuedGiftCardRecordDTO>();

const columns = [
  columnHelper.accessor("giftCardReceiverEmail", {
    header: "Receiver email",
    cell: (info) => <BreakableEmail email={info.getValue()} />,
  }),
  columnHelper.accessor("giftCardCode", {
    header: "Gift card code",
    meta: HIDDEN_ON_MOBILE,
    cell: (info) => (
      <span className={"font-mono text-xs whitespace-nowrap"}>
        {info.getValue()}
      </span>
    ),
  }),
  columnHelper.accessor("referralInviteeEmail", {
    header: "Referral invitee",
    meta: HIDDEN_ON_MOBILE,
    cell: (info) => <BreakableEmail email={info.getValue()} />,
  }),
  columnHelper.accessor("giftCardAmount", {
    header: "Amount",
    cell: (info) => `€${info.getValue()}`,
  }),
  columnHelper.accessor("issuedAt", {
    header: "Issued",
    meta: HIDDEN_ON_MOBILE,
    cell: (info) => (
      <span className={"whitespace-nowrap"}>
        {formatDateTime(info.getValue())}
      </span>
    ),
  }),
  columnHelper.accessor("giftCardExpirationDate", {
    header: "Expires",
    cell: (info) => (
      <span className={"whitespace-nowrap"}>{formatDate(info.getValue())}</span>
    ),
  }),
];

export function IssuedGiftCardsTable({
  issuedGiftCards,
}: {
  issuedGiftCards: IssuedGiftCardRecordDTO[];
}) {
  const table = useReactTable({
    columns,
    data: issuedGiftCards,
    getCoreRowModel: getCoreRowModel(),
  });
  if (issuedGiftCards.length === 0)
    return <EmptyTableMessage message={"No issued gift cards found"} />;
  return (
    <BasicTable
      table={table}
      compact
      scrollableMinWidthClassName={"min-w-full"}
    />
  );
}
